import React, {ReactNode, useEffect} from 'react'
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {useAuthInitWidthTrack} from "@containers/auth/hooks/useAuthInit";
import {useAuthContext} from "@containers/auth/context/hooks/useAuthContext";
import UserActiveAccess from "@containers/account/access/userAccess/UserActiveAccess";
import {buildLoginUrl} from "@containers/auth/helpers/helpers";

interface IProps {
    children: ReactNode
}

const AuthWithTrek = ({children}: IProps) => {

    const {isAuth} = useAuthContext()

    const {isLoading} = useAuthInitWidthTrack()

    const isSignedOut = !isLoading && !isAuth

    useEffect(() => {
        if (isSignedOut) {
            // The sign in is a page of its own: track1 has to see the new cookies on a full load.
            window.location.replace(buildLoginUrl(window.location.pathname + window.location.search))
        }
    }, [isSignedOut]);

    if (isLoading || isSignedOut) {
        return <SpinnerCustom variant={'absolute'}/>
    }


    return (
        <UserActiveAccess>
            {children}
        </UserActiveAccess>
    );
};

export default AuthWithTrek;
